import { telegramGetPeerTmeUrl } from '@synapex/shared2/telegram';

import { ContentContainer, Title, CopyableText, Button } from '@/shared/ui';

import classes from './LoginPage.module.scss';

export const LoginPage = () => {
  return (
    <div className={classes.root}>
      <ContentContainer className={classes.loginWidget}>
        <Title>Авторизуйтесь в Synapex.ai</Title>
        <p className={classes.text}>
          Авторизируйтесь через телеграм-бота &nbsp;
          <span className={classes.blue}>
            <CopyableText text={'@synapex_bot'} />
          </span>
        </p>
        <a
          className={classes.button}
          href={`${telegramGetPeerTmeUrl({ username: import.meta.env.VITE_BOT_USERNAME })}?start=login`}
          rel="noreferrer noopener"
          target="_blank"
        >
          <Button size="fit">Авторизоваться</Button>
        </a>
      </ContentContainer>
    </div>
  );
};
